/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { useEffect } from 'react';
import classnames from 'classnames';
import inView from 'effects/inview';
import './Text.scss';

const DEFAULT_ON_INVIEW = () => {};

function Paragraph({ children }: { children: string }) {
  const [ref, inview] = inView<HTMLParagraphElement>({
    rootMargin: '-30% 0px -20% 0px',
    threshold: [0.1, 0.9],
  });

  return (
    <p
      ref={ref}
      className={classnames({ inview })}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
}

interface TextProps {
  text?: string;
  onInview?: () => void;
}

/**
 * This is the Text component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Text({ text = '', onInview = DEFAULT_ON_INVIEW }: TextProps) {
  const [ref, inview] = inView<HTMLDivElement>({ threshold: [0.1, 0.9] });

  useEffect(() => {
    if (inview) {
      onInview();
    }
  }, [inview]);

  return (
    <div ref={ref} className="text">
      {text.length ? <Paragraph>{text}</Paragraph> : null}
    </div>
  );
}

export default Text;
